export default __webpack_public_path__ + "static/media/us.262c6f5c.svg";